var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumb = function SvgThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7.834 20.333h-2.5a1.667 1.667 0 0 1-1.667-1.666v-5.834a1.667 1.667 0 0 1 1.667-1.666h2.5M13.667 9.5V6.167a2.5 2.5 0 0 0-2.5-2.5l-3.333 7.5v9.166h9.4a1.666 1.666 0 0 0 1.666-1.416l1.15-7.5A1.665 1.665 0 0 0 18.384 9.5z"
  })));
};
export default SvgThumb;